import { useField } from 'formik';
import { default as React } from 'react';
import { FormikSwitch } from '../../Components/FormikFields/FormikSwitch';
import { MedicationListDefaultOverrideStepState } from './MedicationListDefaultOverride';
import styles from './MedicationListDefaultOverrideSection.module.scss';

export type CreateMedicationListSectionProps = {
    title: string;
    field: keyof MedicationListDefaultOverrideStepState;
    subTitle?: string;
    children?: React.ReactNode;
};

export function MedicationListDefaultOverrideSection(props: CreateMedicationListSectionProps): JSX.Element {
    const [field, meta, helpers] = useField(props.field);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titleBlock}>
                    <div>
                        <span className={styles.title}>{props.title}</span>
                    </div>
                    {!!props.subTitle && <div className={styles.subTitle}>{props.subTitle}</div>}
                </div>
                <div className={styles.titleInput}>
                    <FormikSwitch
                        field={props.field}
                        label={field.value ? 'Active' : 'Inactive'}
                        labelPlacement='start'
                        style={{ fontWeight: 'normal' }}
                    />
                </div>
            </div>
            {!!props.children && !!field.value && <div className={styles.body}>{props.children}</div>}
        </div>
    );
}
